import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
} from "@angular/core";
import * as FileSaver from "file-saver";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { DashboardService } from "../../../../core/services/dashboard.service";
import { TableFilterEvent, TableModule } from "primeng/table";
import { DatePickerModule } from "primeng/datepicker";
import { CommonModule } from "@angular/common";
import { QR2Reports } from "../../../../core/models/dashboard/qr2Reports";
import { QR2ReportsDto } from "../../../../core/models/dashboard/qr2ReportsDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { FormsModule } from "@angular/forms";
import { DialogModule } from "primeng/dialog";
import { SelectModule } from "primeng/select";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { OrderSummaryComponent } from "../../../orders/components/order-summary/order-summary.component";
import { ClientDetailsComponent } from "../../../clients/components/client-details/client-details.component";

@Component({
  selector: "jni-qr2-complete",
  templateUrl: "./qr2-complete.component.html",
  styleUrls: ["./qr2-complete.component.scss"],
  imports: [
    TableModule,
    DatePickerModule,
    CommonModule,
    FormsModule,
    DialogModule,
    SelectModule,
    ButtonModule,
    InputTextModule,
    CardModule,
    ModalStackerComponent,
    OrderSummaryComponent,
    ClientDetailsComponent,
  ],
})
export class Qr2CompleteComponent implements OnInit, OnDestroy {
  qr2List: QR2ReportsDto[] = [];
  filteredValues: QR2ReportsDto[] = [];
  filterQr2List: QR2ReportsDto[] = [];
  orderDisplayModal = false;
  clientDisplayModal = false;
  clientId = "";
  saleOrderId = "";
  @Output() scrollHiddenStatus = new EventEmitter();
  @Output() closeEvent = new EventEmitter();
  qR2Reports: QR2Reports = {} as QR2Reports;

  selectedMatchMode = "between";
  startDate = "";
  endDate = "";
  showFilterDialog = false;

  matchModeOptions = [
    { label: "Between", value: "between" },
    { label: "Date is", value: "dateIs" },
    // { label: 'Date not', value: 'dateIsNot' },
    { label: "Date before", value: "dateBefore" },
    { label: "Date after", value: "dateAfter" },
  ];
  isError = false;
  errorLabel = "";
  descriptionCharacterCond = false;
  totalVolume = 0;
  totalNetCommission = 0;
  totalNetCommissionPercentage = 0;

  constructor(
    private _dashboardService: DashboardService,
    private _loaderService: LoaderService,
    private renderer: Renderer2,
    private _toastr: JniToastrService
  ) {}

  ngOnInit(): void {
    this.getQR2Reports();
  }

  getQR2Reports() {
    this._loaderService.setLoaderState(true);
    this._dashboardService.getOrdersWrittenthismonth(0).subscribe({
      next: res => {
        this.qR2Reports = res.data;
        if (this.qR2Reports?.qR2ReportsDtos) {
          this.qr2List = this.qR2Reports.qR2ReportsDtos;
        }
        this.filterQr2List = this.qr2List;
        this.filteredValues = this.filterQr2List;

        // As per the ticket 12162 totals will show on filters
        this.totalVolume = this.filteredValues.reduce(
          (sum, el) => (sum += el.volume ?? 0),
          0
        );

        this.totalNetCommission = this.filteredValues.reduce(
          (sum, el) => (sum += el.netComm ?? 0),
          0
        );

        this.totalNetCommissionPercentage = this.filteredValues.reduce(
          (sum, el) => (sum += el.netGPPercentage ?? 0),
          0
        );
        this._loaderService.setLoaderState(false);
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  onClose() {
    this.closeEvent.emit();
  }
  convertStringToDateExcludeTime(stringDate: string) {
    if (stringDate) {
      return new Date(stringDate).setHours(0, 0, 0, 0);
    } else return new Date();
  }

  getInfinity(percentage: number) {
    if (Number.isFinite(percentage)) {
      return true;
    } else {
      return false;
    }
  }

  redirectToClientSummary(customerAccountNumber: string) {
    // this._router.navigate([
    //   'clients/active/client-details/' + customerAccountNumber
    // ]);
    if (customerAccountNumber) {
      this.clientId = customerAccountNumber;
      this.clientDisplayModal = true;
    }
  }

  redirectToSummary(saleOrderId: string) {
    //this._router.navigate(['orders/order-summary/' + saleOrderId]);
    if (saleOrderId) {
      this.saleOrderId = saleOrderId;
      this.orderDisplayModal = true;
    }
  }

  onFilter(event: TableFilterEvent) {
    this.filteredValues = event.filteredValue;

    // As per the ticket 12162 totals will show on filters
    this.totalVolume = this.filteredValues.reduce(
      (sum, el) => (sum += el.volume ?? 0),
      0
    );

    this.totalNetCommission = this.filteredValues.reduce(
      (sum, el) => (sum += el.netComm ?? 0),
      0
    );

    this.totalNetCommissionPercentage = this.filteredValues.reduce(
      (sum, el) => (sum += el.netGPPercentage ?? 0),
      0
    );
  }

  exportQuadReport2() {
    this.exportExcelForFilterData(this.filteredValues);
  }

  exportExcelForFilterData(filterclientlist: QR2ReportsDto[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["Order Date"]: new Date(datum.orderDate ?? ""),
        ["Order #"]: datum.salesOrderId,
        ["Stat"]: datum.stat,
        ["Client Name"]: datum.clientName,
        ["Job Name"]: datum.jobName,
        ["Volume"]: datum.volume,
        ["Net Comm"]: datum.netComm,
        ["Net GP%"]: datum.netGPPercentage,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "Orders Written this month");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  closeModalForSaleOrder() {
    this.orderDisplayModal = false;
  }

  closeModalForClient() {
    this.clientDisplayModal = false;
  }

  addScollHiddenClass() {
    this.renderer.addClass(document.body, "p-overflow-hidden");
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  clearFilter() {
    this.selectedMatchMode = "";
    this.startDate = "";
    this.endDate = "";
    const filterList = this.qr2List;
    this.filterQr2List = filterList;
  }

  applyFilter() {
    if (this.selectedMatchMode === "between" && this.startDate > this.endDate) {
      this.isError = true;
      this._toastr.error("Error", "Start date must be less than end date");
      return;
    }

    let filterList = this.qr2List;
    switch (this.selectedMatchMode) {
      case "dateIs":
        filterList = this.qr2List.filter(x =>
          x.orderDate
            ? this.convertStringToDateExcludeTime(x.orderDate) ==
              this.convertStringToDateExcludeTime(this.startDate)
            : null
        );
        break;
      // case 'dateIsNot':
      //   filterList = this.qr2List.filter((x) => x.orderDate ? this.convertStringToDateExcludeTime(x.orderDate) !== this.convertStringToDateExcludeTime(this.startDate) : null);
      //   break;
      case "dateBefore":
        filterList = this.qr2List.filter(x =>
          x.orderDate
            ? this.convertStringToDateExcludeTime(x.orderDate) <
              this.convertStringToDateExcludeTime(this.startDate)
            : null
        );
        break;
      case "dateAfter":
        filterList = this.qr2List.filter(x =>
          x.orderDate
            ? this.convertStringToDateExcludeTime(x.orderDate) >
              this.convertStringToDateExcludeTime(this.startDate)
            : null
        );
        break;
      case "between":
        if (this.startDate && this.endDate) {
          filterList = this.qr2List.filter(x => {
            const orderDate = this.convertStringToDateExcludeTime(
              x.orderDate ?? ""
            );
            if (orderDate !== null) {
              return (
                orderDate >=
                  this.convertStringToDateExcludeTime(this.startDate) &&
                orderDate <= this.convertStringToDateExcludeTime(this.endDate)
              );
            }
            return false;
          });
        }
        break;
    }

    this.filterQr2List = filterList;
    this.showFilterDialog = false;
  }

  descriptionCharacterCount(obj: string) {
    if (obj) {
      if (obj.length > 30) this.descriptionCharacterCond = true;
    }
  }
}
